

const inkAvailability = {
  bindings: {
    appointment: '<',
    type: '<?'
  },
  controller: 'AvailabilityController',
  template: require('./availability.template.html')
};

angular
  .module('inkfinder')
  .component('inkAvailability', inkAvailability);



// WEBPACK FOOTER //
// ./components/schedule/availability/availability.component.js